module.exports = __webpack_public_path__ + "static/media/TACM_MENU-normal.a516c8bf.png";